$(document).ready(function(){

  setTimeout(function(){

    $('label.rebuy-checkbox-label').attr('aria-label', 'Rebuy item checkbox');
    $("a.boost-pfs-filter-button[href^='/collections/'] span.boost-pfs-check-box").removeAttr("aria-labelledby");
    $("span.boost-pfs-check-box").removeAttr("aria-labelledby");
    $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/JJUPTn/images/fccd1a80-694c-46fa-9f32-06b603f06da5.png"]').attr('alt', 'earth hero products');
  },1000)
  
$('img[src="/cdn/shop/files/FFFFFF-logomark-and-wordmark_400x.png?v=1657915460"]').attr('alt', 'Earth Hero logo');
$('input.notify-me__input').attr('aria-label', 'Enter your email to get notified');
$('button[is="toggle-button"].icon-text.link.tags-icon[aria-controls^="product-template"]').append('<span style="display:none">.</span>');

$('img[src="/cdn/shop/files/1ftp_Primary_Vertical_White-1_200x.png?v=1744224097"]').attr('alt', '1% for the Planet logo');

$('img[src="/cdn/shop/files/RecycleWithTerraCycle-Logo-WhiteCMYK_EN_200x.png?v=1744828324"]').attr('alt', 'Recycle with TerraCycle logo');
$('img[src="/cdn/shop/files/ClimateNeutralCertified_Label_Vertical_whiteblock_200x.png?v=1744224044"]').attr('alt', 'Climate Neutral Certified logo');
$('a.mega-menu__image-push[href="/products/reusable-paper-towels"]').attr('aria-label', 'Reusable Paper Towels');
$('a.mega-menu__image-push[href="/collections/home-kitchen"]').attr('aria-label', 'Home & Kitchen Collection');

$('a.mobile-nav__image-push[href="/collections/home-kitchen"]').attr('aria-label', 'Home & Kitchen Collection');
$('a.mobile-nav__image-push[href="/products/reusable-paper-towels"]').attr('aria-label', 'Reusable Paper Towels');

$('img[src="//earthhero.com/cdn/shop/files/zero-waste-essentials_5a1d317d-8ae0-47f4-9c56-8d5d9672baff.jpg?v=1718987779&width=246"]').attr('alt', 'Zero waste essentials logo');
$('img[src="//earthhero.com/cdn/shop/files/Terracycle_ee76e604-bddc-4267-90d3-b083ee501eb9.jpg?v=1718899410&width=300"]').attr('alt', 'Terracycle logo');
$('img[src="//earthhero.com/cdn/shop/files/meliora.jpg?v=1718894102&width=300"]').attr('alt', 'Meliora logo');
$('img[src="//earthhero.com/cdn/shop/files/dopps.jpg?v=1718894169&width=300"]').attr('alt', 'Dopps logo');
$('img[src="//earthhero.com/cdn/shop/files/biobag.jpg?v=1718894190&width=300"]').attr('alt', 'Biobag logo');
$('img[src="//earthhero.com/cdn/shop/files/Bumbleride_8ece3d66-8dd0-4764-95b0-2572c2acc796.jpg?v=1718899484&width=300"]').attr('alt', 'Bumbleride logo');
$('img[src="//earthhero.com/cdn/shop/files/unpaste.jpg?v=1718894221&width=300"]').attr('alt', 'Unpaste logo');
$('img[src="//earthhero.com/cdn/shop/files/plaine-products.jpg?v=1718894241&width=300"]').attr('alt', 'Plaine Products logo');
$('img[src="//earthhero.com/cdn/shop/files/holy-lamb-organics.jpg?v=1718894257&width=300"]').attr('alt', 'Holy Lamb Organics logo');
$('img[src="//earthhero.com/cdn/shop/files/Suds_Eco.jpg?v=1718899502&width=300"]').attr('alt', 'Suds Eco logo');
$('img[src="//earthhero.com/cdn/shop/files/fat-and-the-moon.jpg?v=1718894296&width=300"]').attr('alt', 'Fat and the Moon logo');
$('img[src="//earthhero.com/cdn/shop/files/Terra_Thread.jpg?v=1718899541&width=300"]').attr('alt', 'Terra Thread logo');

  let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if ( $('label.rebuy-checkbox-label').length) {

 $('label.rebuy-checkbox-label').attr('aria-label', 'Rebuy item checkbox');
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$('img[src*="d1D6042-logomark-and-wordmark_420x.png"]').attr('alt', 'Earth Hero logo');

   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');
$('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/JJUPTn/images/fccd1a80-694c-46fa-9f32-06b603f06da5.png"]').attr('alt', 'Wash basin image with toothpaste and handwash');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
  $("span.sale.boost-pfs-filter-label.boost-pfs-filter-label-display-sale_SAVE").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });


  let Intervaltime_task1;
let counter_task1 = 0; 


try {
    Intervaltime_task1 = setInterval(GenerateAriaLabelFortask1, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask1() {
   
   counter_task1++;


   
    if ( $("span.boost-pfs-check-box").length) {

$("span.boost-pfs-check-box").removeAttr("aria-labelledby");
        clearInterval(Intervaltime_task1);
       
    }
    
  
    if (counter_task1 >= 20) {
        clearInterval(Intervaltime_task1);
       
    }
}
$('img[src="/cdn/shop/files/1D6042-logomark-and-wordmark_420x.png?v=1657915460"]').attr('alt', 'Earth Hero logo');


  


  

});
